import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// Components
import { CatalogListing } from '@mobilitystore/components-interface';
import CustomizedSnackbars from '../../../components/Shared/Utils/SnackBar';

// Constants
import idConstants from '../../../data/idConstants';

// Actions
import { regenerateAAATokens } from '../../../actions/LoginAction';

// Utils
import { getEnvironment } from '../../../utils';

// CSS
import '../index.scss';
import './index.scss';

const BulkProductListingContainer = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const initialSnackbarState = {
    status: '',
    show: false
  };

  const { userCompanyStatus } = useSelector((state) => {
    return {
      userCompanyStatus: state.CompanyDetailsReducer.userCompanyStatus
    };
  });

  const [snackbarStatus, setSnackbarStatus] = React.useState(initialSnackbarState);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleBulkProductListingSuccess = (message) => {
    setSnackbarStatus({
      status: 'success',
      message: message,
      show: true
    });
  };

  const handleBulkProductListingError = (error) => {
    setSnackbarStatus({
      status: 'error',
      message: error.message,
      show: true
    });

    if (error.error === 'ERR_NETWORK') {
      dispatch(regenerateAAATokens()).then(() => {
        window.location.reload();
      });
    }
  };

  const handlePublish = (data, statusId) => {
    const modifiedState = {
      basicInfo: {
        productCategoryId: data.categoryId,
        productCategoryName: data.categoryName
      },
      catalogData: {
        catalogJobId: data.jobId,
        catalogName: data.catalogName,
        brand: data.brand,
        provider: data.provider,
        providerDisplayName: data.providerDisplayName
      }
    };
    history.push({
      pathname: `/add-product`,
      state: modifiedState
    });
  };

  return (
    <div>
      {snackbarStatus.show && (
        <CustomizedSnackbars
          severity={snackbarStatus.status}
          message={snackbarStatus.message}
          changeState={() => setSnackbarStatus(initialSnackbarState)}
        />
      )}
      <CatalogListing
        className='bulk-product-listing'
        token={localStorage.getItem(idConstants.tokens.aaaIdToken)}
        environment={getEnvironment(process.env.REACT_APP_ENVIRONMENT)}
        tenantId={process.env.REACT_APP_SELLER_TENANT_ID}
        onHeaderButtonClick={() => {
          window.scrollTo(0, 0);
          history.push('/dashboard/bulk-product/upload');
        }}
        onViewDetailsClick={(data) =>
          history.push({
            pathname: `/dashboard/bulk-product/product-details/${data.catalogItemId}`,
            state: { productId: data.catalogItemId }
          })
        }
        onPublishClick={handlePublish}
        sellerCompanyId={userCompanyStatus?.companyId}
        onSuccess={handleBulkProductListingSuccess}
        onError={handleBulkProductListingError}
        isBulkOnboarding={true}
      />
    </div>
  );
};

export default BulkProductListingContainer;
